if (typeof alpineData !== "undefined") {
    function googleReady() {
        document.dispatchEvent(new Event("google:init"));
    }
    document.addEventListener("alpine:init", () => {
        Alpine.data("googlePlacesAutocomplete", () => ({
            showClusters: alpineData.clusters,
            nearestLocation: alpineData.nearest_location,
            linkToLocationPage: alpineData.link_to_location_page,
            panToMarker: alpineData.pan_to_marker,
            panToMarkerZoomlevel: alpineData.pan_to_marker_zoom_level,
            google: {},
            locationsStyle: "",
            locations: [],
            filteredLocations: [],
            markers: [],
            infowindow: null,
            markerCluster: null,
            address: "",
            map: null,
            autocomplete: null,
            filters: [],
            activeFilters: [],
            init() {
                if (typeof window.google === "undefined") {
                    document.addEventListener("google:init", () => {
                        this.initAutocomplete();
                    });
                } else {
                    this.initAutocomplete();
                }
            },
            async initAutocomplete() {
                const { LatLng, LatLngBounds } = await google.maps.importLibrary("core");
                const { Geocoder } = await google.maps.importLibrary("geocoding");
                const { Map } = await google.maps.importLibrary("maps");
                const { Marker, AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");
                const { Autocomplete } = await google.maps.importLibrary("places");
                const { InfoWindow } = await google.maps.importLibrary("streetView");
                this.google = {
                    LatLng,
                    LatLngBounds,
                    Geocoder,
                    Map,
                    Marker,
                    AdvancedMarkerElement,
                    PinElement,
                    Autocomplete,
                    InfoWindow,
                };

                this.autocomplete = new this.google.Autocomplete(this.$refs.googleAutocomplete, {
                    componentRestrictions: {
                        country: ["nl"],
                    },
                });
                this.autocomplete.addListener("place_changed", () => this.handleResponse(this.autocomplete.getPlace()));

                this.map = new this.google.Map(this.$refs.googleMap, {
                    zoom: 10,
                    center: { lat: 52.9640223, lng: 5.7975938 },
                    mapId: alpineData.map_id,
                });

                this.infowindow = new this.google.InfoWindow();
                this.markerCluster =
                    this.showClusters && typeof markerClusterer !== "undefined"
                        ? new markerClusterer.MarkerClusterer({
                              map: Alpine.raw(this.map),
                              markers: [],
                              renderer: {
                                  render: ({ count, position }) => {
                                      const svg = `<svg fill="#ff0000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
                                    <circle cx="120" cy="120" opacity=".6" r="70" />
                                    <circle cx="120" cy="120" opacity=".3" r="90" />
                                    <circle cx="120" cy="120" opacity=".2" r="110" />
                                    <text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${count}</text>
                                    </svg>`;
                                      const parser = new DOMParser();
                                      const svgEl = parser.parseFromString(svg, "image/svg+xml").documentElement;
                                      svgEl.setAttribute("transform", "translate(0 25)");
                                      const title = `Cluster of ${count} markers`;
                                      const zIndex = Number(Marker.MAX_ZINDEX) + count;

                                      return new this.google.AdvancedMarkerElement({
                                          position,
                                          zIndex,
                                          title,
                                          content: svgEl,
                                      });
                                  },
                              },
                          })
                        : null;

                this.$watch("filters", () => {
                    this.resizeListBox();
                });

                this.getLocations();
                this.filters = alpineData.filters;

                if (this.nearestLocation && navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition((position) => {
                        const geocoder = new this.google.Geocoder();
                        const pos = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude,
                        };
                        this.geocodeLatLng(geocoder, pos);
                    });
                }

                this.$watch("activeFilters", () => {
                    if (this.activeFilters.length) {
                        this.filteredLocations = this.locations.filter((location) =>
                            location.categories.some((category) => this.activeFilters.includes(category)),
                        );
                        this.markers.forEach((marker) => {
                            if (marker.custom) {
                                return;
                            }

                            if (marker.categories?.some((category) => this.activeFilters.includes(category))) {
                                !this.showClusters && (marker.marker.map = Alpine.raw(this.map));
                                this.showClusters && this.markerCluster.addMarker(Alpine.raw(marker.marker), true);
                            } else {
                                !this.showClusters && (marker.marker.map = null);
                                this.showClusters && this.markerCluster.removeMarker(Alpine.raw(marker.marker), true);
                            }
                        });
                    } else {
                        this.filteredLocations = this.locations;
                        this.markers.forEach((marker) => {
                            if (marker.custom) {
                                return;
                            }

                            !this.showClusters && (marker.marker.map = Alpine.raw(this.map));
                            this.showClusters && this.markerCluster.addMarker(Alpine.raw(marker.marker), true);
                        });
                    }
                    this.refreshMap();
                });

                // Listen to the resize event for styling the location list.
                window.addEventListener(
                    "resize",
                    () => {
                        this.resizeListBox();
                    },
                    { passive: true },
                );
            },
            handleResponse(addressData) {
                // Add a custom marker for the searched location.
                addressData.hasOwnProperty("geometry") &&
                    this.pushCustomMarker(
                        addressData.formatted_address,
                        addressData.geometry.location.lat(),
                        addressData.geometry.location.lng(),
                    );

                // Remove our custom marker if it exists when no address has been selected.
                !addressData.hasOwnProperty("geometry") && this.removeCustomMarker();
            },
            pushCustomMarker(address, lat, lng) {
                // Remove our custom marker if it exists, so we don't have duplicates.
                this.removeCustomMarker();

                const html =
                    '<span class="infowindow-title">Eigen locatie</span><span class="infowindow-address">' +
                    address +
                    "</span>";
                const newMarker = {
                    custom: true,
                    position: {
                        lat,
                        lng,
                    },
                    marker: this.createMarker(lat, lng, html, true, true),
                };
                this.markers.push(newMarker);

                this.refreshMap();
            },
            removeCustomMarker() {
                this.markers = this.markers.filter((marker) => {
                    if (marker.custom === true && marker.marker) {
                        marker.marker.map = null;
                        marker.marker.position = null;
                        marker.marker = null;

                        return false;
                    }

                    return true;
                });
            },
            createMarker(lat, lng, html, setMap = false, customIcon = false) {
                const marker = new this.google.AdvancedMarkerElement({
                    position: new this.google.LatLng(lat, lng),
                    content: customIcon
                        ? new this.google.PinElement({
                              background: "#ea9690",
                              borderColor: "#ffffff",
                              glyphColor: "#804a48",
                          }).element
                        : null,
                    title: html,
                });
                setMap && (marker.map = Alpine.raw(this.map));

                marker.addListener("click", () => {
                    this.infowindow.setContent(html);
                    this.infowindow.open(this.map, marker);
                });

                return marker;
            },
            refreshMap() {
                if (this.markers.length < 1) {
                    return;
                }

                const lastMarker = this.markers[this.markers.length - 1];
                if (lastMarker.custom) {
                    this.filteredLocations = this.filteredLocations
                        .map((el) => ({
                            ...el,
                            distance: Math.round(this.haversineDistance(lastMarker.position, el.position) * 1e2) / 1e2,
                        }))
                        .sort((a, b) => a.distance - b.distance);
                }

                // Get the bounds of each marker and fit them to map.
                const bounds = new this.google.LatLngBounds();
                this.filteredLocations.forEach((location) => {
                    bounds.extend(location.position);
                });
                bounds.extend(lastMarker.position);
                this.map.fitBounds(bounds);

                this.map.setZoom(this.map.getZoom());
            },
            resultsListClick(location) {
                if (location.clickable === false) {
                    this.map.setZoom(parseInt(this.panToMarkerZoomlevel));
                    this.map.panTo({
                        lat: parseFloat(location.position.lat),
                        lng: parseFloat(location.position.lng),
                    });

                    return;
                }

                if (this.linkToLocationPage) {
                    window.location = location.link;
                } else if (this.panToMarker) {
                    this.map.setZoom(parseInt(this.panToMarkerZoomlevel));
                    this.map.panTo({
                        lat: parseFloat(location.position.lat),
                        lng: parseFloat(location.position.lng),
                    });
                }
            },
            geocodeLatLng(geocoder, map) {
                geocoder.geocode(
                    {
                        location: map,
                    },
                    (results, status) => {
                        if (status === "OK") {
                            if (results[0]) {
                                this.address = results[0].formatted_address;
                                this.pushCustomMarker(results[0].formatted_address, map.lat, map.lng);
                            } else {
                                console.log("Geen resulaten gevonden.");
                            }
                        } else {
                            console.log(`Geocoder mislukt: ${status}`);
                        }
                    },
                );
            },
            getLocations() {
                let locations = alpineData.locations;
                // Add a marker for each location.
                locations.forEach((item) => {
                    const location = {
                        custom: false,
                        id: item.id,
                        title: item.title,
                        excerpt: item.excerpt,
                        thumbnail: item.thumbnail,
                        link: item.link,
                        categories: item.categories,
                        address: item.address ?? "",
                        position: {
                            lat: parseFloat(item.acf.map.lat),
                            lng: parseFloat(item.acf.map.lng),
                        },
                        clickable: item.acf.clickable ?? null,
                    };
                    this.locations.push(location);
                    this.filteredLocations.push(location);

                    let html =
                        '<a href="' +
                        location.link +
                        '" class="infowindow-title">' +
                        location.title +
                        '</a><span class="infowindow-address">' +
                        location.address +
                        "</span>";
                    if (location.clickable === false) {
                        html =
                            '<span class="infowindow-title">' +
                            location.title +
                            '</span><span class="infowindow-address">' +
                            location.address +
                            "</span>";
                    }

                    const newMarker = {
                        custom: false,
                        title: item.title,
                        categories: item.categories,
                        position: {
                            lat: parseFloat(item.acf.map.lat),
                            lng: parseFloat(item.acf.map.lng),
                        },
                        marker: this.createMarker(
                            parseFloat(item.acf.map.lat),
                            parseFloat(item.acf.map.lng),
                            html,
                            !this.showClusters,
                        ),
                    };
                    this.markers.push(newMarker);
                    this.showClusters && this.markerCluster.addMarker(newMarker.marker);
                });

                this.refreshMap();
                this.resizeListBox();
            },
            resizeListBox() {
                const heightString = this.$refs.locations.clientHeight - 32 + "px";
                this.locationsStyle = {
                    overflowY: "scroll",
                    height: heightString,
                };
            },
            haversineDistance(coords1, coords2) {
                function toRad(x) {
                    return (x * Math.PI) / 180;
                }

                const lat1 = coords1.lat;
                const lon1 = coords1.lng;
                const lat2 = coords2.lat;
                const lon2 = coords2.lng;

                const R = 6371; // km

                const x1 = lat2 - lat1;
                const dLat = toRad(x1);
                const x2 = lon2 - lon1;
                const dLon = toRad(x2);
                const a =
                    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
                const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                const d = R * c;

                return d;
            },
        }));
    });
}
